<template>
    <div style="padding: 10px 20px; max-height: calc(100vh - 70px); overflow-y: auto;">
        <div style="display: grid; grid-template-rows: auto; grid-template-columns: 33% 33% 33%;">
            <div v-for="system in systems" :key="system.id" >
                <system-herd-weight-card :system="system"/>
            </div>
        </div>
    </div>
</template>

<script>
import { getSystemsStatusList } from "@api";
import SystemHerdWeightCard from '../components/Systems/SystemHerdWeightCard.vue';

export default {
    components: {
        SystemHerdWeightCard
    },
    data() {
        return {
            systems: []
        }
    },
    methods: {
        async getData() {
            var result = await getSystemsStatusList();
            this.systems = result.filter(x => x.hasWeight).sort(this.sortSystemsByName);
        },
        sortSystemsByName(a, b){
			return (a.name.localeCompare(b.name, undefined, {
              numeric: true,
              sensitivity: 'base'
            }));
		},
    },
    mounted: async function() {
        this.getData();
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/HerdsWeightView.vue